import React, { useState, useEffect } from "react";
import CmtCardContent from "@coremat/CmtCard/CmtCardContent";
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  Grid,
  TextField,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CmtCardFooter from "@coremat/CmtCard/CmtCardFooter";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import { Add, Remove } from "@material-ui/icons";
import { useDispatch, useSelector } from "react-redux";
import CmtCard from "@coremat/CmtCard";
import GridContainer from "@jumbo/components/GridContainer";
import NewsRequests from "services/news";

import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import "@ckeditor/ckeditor5-build-classic/build/translations/fa";
import ImagePicker from "../Tests/compnents/ImagePicker";
import FileUploader from "../Media/FileUploader";

import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import gregorian from "react-date-object/calendars/gregorian";
import gregorian_en from "react-date-object/locales/gregorian_en";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import InventoryLogCard from "./InventoryLogCard";

const useStyles = makeStyles((theme) => ({
  cardContainer: {
    marginTop: 10,
  },
  titleInput: {
    width: "100%",
  },
  formControl: {
    width: "100%",
  },
  title: {
    color: theme.palette.primary.main,
    marginBlock: "16px",
    fontWeight: "bold",
  },
  previewContainer: {
    width: "100%",
    display: "flex",
    marginTop: "16px",
    justifyContent: "center",
    "& img": {
      width: "190px",
      marginInline: "auto",
      borderRadius: "1rem",
    },
  },
  removeButton: {
    cursor: "pointer",
  },
  noLeftBorder: {
    borderRight: "none",
    borderRadius: "4px 0px 0px 4px",
  },
  inputContainer: {
    width: "100%",
    display: "flex",
  },
  leftButton: {
    borderTopLeftRadius: "0px",
    borderBottomLeftRadius: "0px",
  },
}));

const Prize = ({ prize }) => {
  const now = new Date();
  now.setHours(18, 0, 0, 0);

  const dateFormat = {
    date: now,
    gregorian: new DateObject({ date: now, format: "HH:mm:ss   YYYY/MM/DD" })
      .convert(gregorian, gregorian_en)
      .format(),
  };
  const classes = useStyles();
  const dispatch = useDispatch();

  const { message } = useSelector(({ common }) => common);

  const [name, setName] = useState("");
  const [desc, setDesc] = useState("");
  const [price, setPrice] = useState("");
  const [cover, setCover] = useState("");
  const [active, setActive] = useState(true);
  const [expirationEnabled, setExpirationEnabled] = useState(false);
  const [expirationDate, setExpirationDate] = useState(dateFormat);
  const [limitPerFamily, setLimitPerFamily] = useState(false);
  const [deliveryNote, setDeliveryNote] = useState("");

  const [openDialog, setOpenDialog] = useState(false);
  const [openEditDialog, setopenEditDialog] = useState(false);
  const [openAddDialog, setOpenAddDialog] = useState(false);
  const [inventoryDialog, setInventoryDialog] = useState(null);
  const [inventoryValue, setInventoryValue] = useState("");
  const [inventoryDescription, setInventoryDescription] = useState("");
  const [inventorySubmitting, setInventorySubmitting] = useState(false);
  const [inventoryLogs, setInventoryLogs] = useState([]);
  const [inventoryLogPage, setInventoryLogPage] = useState(1);
  const [inventoryLogTotalPages, setInventoryLogTotalPages] = useState(0);
  const [inventoryLogSource, setInventoryLogSource] = useState("All");

  const [openFileUploader, setOpenFileUploader] = useState(false);
  // Cancel settings
  const [cancelEnabled, setCancelEnabled] = useState(false);
  const [cancelLimitToDate, setCancelLimitToDate] = useState(false);
  const [cancelDate, setCancelDate] = useState(dateFormat);
  const [cancelLimitToDay, setCancelLimitToDay] = useState(false);
  const [cancelDay, setCancelDay] = useState("");
  const [cancelReturnToInventory, setCancelReturnToInventory] = useState(false);
  const [cancelPenalty, setCancelPenalty] = useState(0);
  // Expire settings
  const [expireEnabled, setExpireEnabled] = useState(false);
  const [expireLimitToDate, setExpireLimitToDate] = useState(false);
  const [expireDate, setExpireDate] = useState(dateFormat);
  const [expireLimitToDay, setExpireLimitToDay] = useState(false);
  const [expireDay, setExpireDay] = useState("");
  const [expireReturnToInventory, setExpireReturnToInventory] = useState(false);
  const [expirePenalty, setExpirePenalty] = useState(0);

  const resetState = () => {
    setName("");
    setDesc("");
    setPrice("");
    setCover("");
    setActive(true);
    setDeliveryNote("");
    // Reset cancellSetting
    setCancelEnabled(false);
    setCancelLimitToDate(false);
    setCancelDate(dateFormat);
    setCancelLimitToDay(false);
    setCancelDay("");
    setCancelReturnToInventory(false);
    setCancelPenalty(0);

    // Reset expireSetting
    setExpireEnabled(false);
    setExpireLimitToDate(false);
    setExpireDate(dateFormat);
    setExpireLimitToDay(false);
    setExpireDay("");
    setExpireReturnToInventory(false);
    setExpirePenalty(0);
  };

  useEffect(() => {
    if (message === "با موفقیت اضافه شد") {
      resetState();
    }
  }, [message]);

  useEffect(() => {
    if (prize) {
      setName(prize.name);
      setDesc(prize.description);
      setPrice(prize.price);
      setCover(prize.cover);
      setActive(prize.active);
      setDeliveryNote(prize.deliveryNote || "");
      // Load cancellSetting
      const cancel = prize.cancellSetting || {};
      setCancelEnabled(cancel.enabled || false);
      setCancelLimitToDate(cancel.limitToDate || false);
      setCancelDate(
        cancel.limitToDateDate
          ? {
              date: new Date(cancel.limitToDateDate),
              gregorian: new DateObject({
                date: new Date(cancel.limitToDateDate),
                format: "HH:mm:ss   YYYY/MM/DD",
              })
                .convert(gregorian, gregorian_en)
                .format(),
            }
          : dateFormat
      );
      setCancelLimitToDay(cancel.limitToDay || false);
      setCancelDay(cancel.limitToDayDay || "");
      setCancelReturnToInventory(cancel.returnToInventory || false);
      setCancelPenalty(cancel.penallty || 0);

      // Load expireSetting
      const expire = prize.expireSetting || {};
      setExpireEnabled(expire.enabled || false);
      setExpireLimitToDate(expire.limitToDate || false);
      setExpireDate(
        expire.limitToDateDate
          ? {
              date: new Date(expire.limitToDateDate),
              gregorian: new DateObject({
                date: new Date(expire.limitToDateDate),
                format: "HH:mm:ss   YYYY/MM/DD",
              })
                .convert(gregorian, gregorian_en)
                .format(),
            }
          : dateFormat
      );
      setExpireLimitToDay(expire.limitToDay || false);
      setExpireDay(expire.limitToDayDay || "");
      setExpireReturnToInventory(expire.returnToInventory || false);
      setExpirePenalty(expire.penallty || 0);
      setExpirationEnabled(prize.displayDateEnabled || false);
      setExpirationDate(
        prize.displayDate
          ? {
              date: new Date(prize.displayDate),
              gregorian: new DateObject({
                date: new Date(prize.displayDate),
                format: "HH:mm:ss   YYYY/MM/DD",
              })
                .convert(gregorian, gregorian_en)
                .format(),
            }
          : dateFormat
      );
      setLimitPerFamily(prize.limitPerFamily || false);
    }
  }, [prize]);

  const prizeId = prize?._id || prize?.id;

  useEffect(() => {
    if (!prizeId) {
      setInventoryLogs([]);
      setInventoryLogPage(1);
      setInventoryLogTotalPages(0);
      return;
    }

    dispatch(
      NewsRequests.getPrizeInventoryLogs(prizeId, 1, 10, inventoryLogSource)
    )
      .then((data) => {
        setInventoryLogs(data.docs);
        setInventoryLogPage(data.page);
        setInventoryLogTotalPages(data.totalPages);
      })
      .catch(() => {});
  }, [dispatch, prizeId, inventoryLogSource]);

  const handleAddAndClose = () => {
    const prizeData = {
      name,
      description: desc,
      price,
      cover,
      active,
      deliveryNote,
      cancellSetting: {
        enabled: cancelEnabled,
        limitToDate: cancelLimitToDate,
        limitToDateDate: cancelLimitToDate
          ? convertToStandardFormat(cancelDate.gregorian)
          : null,
        limitToDay: cancelLimitToDay,
        limitToDayDay: cancelLimitToDay ? cancelDay : null,
        returnToInventory: cancelReturnToInventory,
        penallty: cancelPenalty,
      },
      expireSetting: {
        enabled: expireEnabled,
        limitToDate: expireLimitToDate,
        limitToDateDate: expireLimitToDate
          ? convertToStandardFormat(expireDate.gregorian)
          : null,
        limitToDay: expireLimitToDay,
        limitToDayDay: expireLimitToDay ? expireDay : null,
        returnToInventory: expireReturnToInventory,
        penallty: expirePenalty,
      },
      displayDateEnabled: expirationEnabled,
      displayDate: expirationEnabled
        ? convertToStandardFormat(expirationDate.gregorian)
        : null,
      limitPerFamily: limitPerFamily,
    };
    dispatch(NewsRequests.addPrize(prizeData));
    setOpenAddDialog(false);
  };

  const handleEditAndClose = () => {
    const prizeData = {
      name,
      description: desc,
      price,
      cover,
      active,
      deliveryNote,
      cancellSetting: {
        enabled: cancelEnabled,
        limitToDate: cancelLimitToDate,
        limitToDateDate: cancelLimitToDate
          ? convertToStandardFormat(cancelDate.gregorian)
          : null,
        limitToDay: cancelLimitToDay,
        limitToDayDay: cancelLimitToDay ? cancelDay : null,
        returnToInventory: cancelReturnToInventory,
        penallty: cancelPenalty,
      },
      expireSetting: {
        enabled: expireEnabled,
        limitToDate: expireLimitToDate,
        limitToDateDate: expireLimitToDate
          ? convertToStandardFormat(expireDate.gregorian)
          : null,
        limitToDay: expireLimitToDay,
        limitToDayDay: expireLimitToDay ? expireDay : null,
        returnToInventory: expireReturnToInventory,
        penallty: expirePenalty,
      },
      displayDateEnabled: expirationEnabled,
      displayDate: expirationEnabled
        ? convertToStandardFormat(expirationDate.gregorian)
        : null,
      limitPerFamily: limitPerFamily,
    };
    dispatch(NewsRequests.updatePirze(prize._id || prize.id, prizeData));
    setopenEditDialog(false);
  };

  const handleClose = () => {
    setOpenDialog(false);
  };

  const handleRemoveAndClose = () => {
    dispatch(NewsRequests.removeSinglePrize(prize._id || prize.id));
    setOpenDialog(false);
  };

  const closeInventoryDialog = () => {
    if (inventorySubmitting) return;
    setInventoryDialog(null);
    setInventoryValue("");
    setInventoryDescription("");
  };

  const handleInventorySubmit = async () => {
    const value = Number(inventoryValue);
    if (
      !Number.isInteger(value) ||
      value <= 0 ||
      !inventoryDescription.trim() ||
      (inventoryDialog === "remove" && value > prize.inventory)
    ) {
      return;
    }

    setInventorySubmitting(true);
    try {
      await dispatch(
        NewsRequests.adjustPrizeInventory(
          prize._id || prize.id,
          inventoryDialog,
          {
            description: inventoryDescription.trim(),
            value,
          }
        )
      );
      setInventoryDialog(null);
      setInventoryValue("");
      setInventoryDescription("");
      dispatch(NewsRequests.getSinglePrize(prize._id || prize.id));
      dispatch(
        NewsRequests.getPrizeInventoryLogs(
          prize._id || prize.id,
          1,
          10,
          inventoryLogSource
        )
      )
        .then((data) => {
          setInventoryLogs(data.docs);
          setInventoryLogPage(data.page);
          setInventoryLogTotalPages(data.totalPages);
        })
        .catch(() => {});
    } catch {
      // The request service displays the backend error through global feedback.
    } finally {
      setInventorySubmitting(false);
    }
  };

  const validInventoryInput =
    Number.isInteger(Number(inventoryValue)) &&
    Number(inventoryValue) > 0 &&
    (inventoryDialog !== "remove" ||
      Number(inventoryValue) <= prize?.inventory) &&
    inventoryDescription.trim().length > 0;

  const handleInventoryLogPageChange = (_, page) => {
    dispatch(
      NewsRequests.getPrizeInventoryLogs(
        prizeId,
        page,
        10,
        inventoryLogSource
      )
    )
      .then((data) => {
        setInventoryLogs(data.docs);
        setInventoryLogPage(data.page);
        setInventoryLogTotalPages(data.totalPages);
      })
      .catch(() => {});
  };

  const convertToStandardFormat = (dateString) => {
    const [time, date] = dateString.split("   ");
    const [hours, minutes, seconds] = time.split(":");
    const [year, month, day] = date.split("/");
    const standardFormat = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
    const dateObject = new Date(standardFormat);
    const isoString = dateObject.toISOString();
    return isoString;
  };

  return (
    <React.Fragment>
      <div className={classes.cardContainer}>
        <CmtCard>
          <CmtCardContent>
            <GridContainer>
              <Grid item xs={12}>
                <ImagePicker
                  cover={cover}
                  handlePick={() => setOpenFileUploader(true)}
                  handleRevome={() => setCover("")}
                  previewStyles={{ marginInline: "auto", marginBlock: "20px" }}
                  placeHolderStyles={{
                    marginInline: "auto",
                    marginBlock: "20px",
                  }}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  id="prizeTitle"
                  label="عنوان جایزه"
                  variant="outlined"
                  className={classes.titleInput}
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography className={classes.title}>توضیحات</Typography>
                <CKEditor
                  editor={ClassicEditor}
                  config={{
                    language: "fa",
                    toolbar: [
                      "heading",
                      "|",
                      "bold",
                      "italic",
                      "link",
                      "bulletedList",
                      "numberedList",
                      "blockQuote",
                    ],
                    link: {
                      addTargetToExternalLinks: true,
                      decorators: [
                        {
                          mode: "manual",
                          label: "باز کردن در تب جدید",
                          attributes: {
                            target: "_blank",
                          },
                        },
                      ],
                    },
                  }}
                  data={desc}
                  onChange={(_, editor) => {
                    const data = editor.getData();
                    setDesc(data);
                  }}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <Typography className={classes.title}>قیمت</Typography>
                <TextField
                  id="priceField"
                  label="قیمت"
                  variant="outlined"
                  type="number"
                  className={classes.formControl}
                  value={price}
                  onChange={(e) => setPrice(e.target.value)}
                  onWheel={(e) => e.target.blur()}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography className={classes.title}>موجودی</Typography>
                <TextField
                  id="inventoryField"
                  label="موجودی"
                  variant="outlined"
                  type="number"
                  className={classes.formControl}
                  value={prize ? prize.inventory : 0}
                  disabled
                />
                {prize && (
                  <Box mt={2} display="flex">
                    <Button
                      variant="outlined"
                      color="primary"
                      startIcon={<Add />}
                      onClick={() => setInventoryDialog("add")}
                    >
                      افزایش موجودی
                    </Button>
                    <Button
                      variant="outlined"
                      color="secondary"
                      startIcon={<Remove />}
                      onClick={() => setInventoryDialog("remove")}
                      disabled={prize.inventory < 1}
                      style={{ marginRight: 12 }}
                    >
                      کاهش موجودی
                    </Button>
                  </Box>
                )}
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography className={classes.title}>
                  نمایش به کاربر
                </Typography>
                <FormControlLabel
                  style={{ paddingRight: "20px" }}
                  control={
                    <Checkbox
                      color="primary"
                      checked={active}
                      onChange={() => setActive((prev) => !prev)}
                      name="new window"
                    />
                  }
                  label="نمایش به کاربر"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography className={classes.title}>
                  محدودیت خرید کدپرسنلی
                </Typography>
                <FormControlLabel
                  style={{ paddingRight: "20px" }}
                  control={
                    <Checkbox
                      color="primary"
                      checked={limitPerFamily}
                      onChange={() => setLimitPerFamily((prev) => !prev)}
                      name="new window"
                    />
                  }
                  label="محدودیت خرید کدپرسنلی"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography className={classes.title}>
                  تاریخ موجودی محصول
                </Typography>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={expirationEnabled}
                      onChange={(e) => setExpirationEnabled(e.target.checked)}
                    />
                  }
                  label="تاریخ موجودی محصول"
                />
                {expirationEnabled && (
                  <Box mt={1}>
                    <DatePicker
                      containerClassName="custom-container"
                      calendar={persian}
                      locale={persian_fa}
                      format="HH:mm:ss   YYYY/MM/DD"
                      plugins={[<TimePicker position="right" />]}
                      value={expirationDate.date}
                      onChange={(date) =>
                        setExpirationDate({
                          date,
                          gregorian: new DateObject({
                            date,
                            format: "HH:mm:ss   YYYY/MM/DD",
                          })
                            .convert(gregorian, gregorian_en)
                            .format(),
                        })
                      }
                    />
                  </Box>
                )}
              </Grid>

              <Grid item xs={12}>
                <Typography
                  variant="h6"
                  gutterBottom
                  style={{ fontWeight: "bold" }}
                >
                  تنظیمات انصراف
                </Typography>

                <FormControlLabel
                  control={
                    <Checkbox
                      checked={cancelEnabled}
                      onChange={(e) => setCancelEnabled(e.target.checked)}
                    />
                  }
                  label="فعال‌سازی انصراف"
                />

                {cancelEnabled && (
                  <Grid container spacing={2} style={{ marginTop: 8 }}>
                    <Grid item xs={12} md={6}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={cancelLimitToDate}
                            onChange={(e) =>
                              setCancelLimitToDate(e.target.checked)
                            }
                          />
                        }
                        label="محدودیت بر اساس تاریخ"
                      />
                      {cancelLimitToDate && (
                        <Box mt={1}>
                          <DatePicker
                            containerClassName="custom-container"
                            calendar={persian}
                            locale={persian_fa}
                            format="HH:mm:ss   YYYY/MM/DD"
                            plugins={[<TimePicker position="right" />]}
                            value={cancelDate.date}
                            onChange={(date) =>
                              setCancelDate({
                                date,
                                gregorian: new DateObject({
                                  date,
                                  format: "HH:mm:ss   YYYY/MM/DD",
                                })
                                  .convert(gregorian, gregorian_en)
                                  .format(),
                              })
                            }
                          />
                        </Box>
                      )}
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={cancelLimitToDay}
                            onChange={(e) =>
                              setCancelLimitToDay(e.target.checked)
                            }
                          />
                        }
                        label="محدودیت بر اساس تعداد روز"
                      />
                      {cancelLimitToDay && (
                        <Box marginTop={"16px"}>
                          <TextField
                            label="تعداد روز"
                            type="number"
                            variant="outlined"
                            fullWidth
                            value={cancelDay}
                            onChange={(e) => setCancelDay(e.target.value)}
                            style={{ marginTop: 8 }}
                          />
                        </Box>
                      )}
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={cancelReturnToInventory}
                            onChange={(e) =>
                              setCancelReturnToInventory(e.target.checked)
                            }
                          />
                        }
                        label="بازگشت به موجودی"
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <TextField
                        label="درصد جریمه"
                        type="number"
                        fullWidth
                        value={cancelPenalty}
                        variant="outlined"
                        onChange={(e) => {
                          const value = e.target.value;
                          if (
                            value === "" ||
                            (Number(value) >= 0 && Number(value) <= 100)
                          ) {
                            setCancelPenalty(value);
                          }
                        }}
                        InputProps={{
                          endAdornment: <span>%</span>,
                        }}
                      />
                    </Grid>
                  </Grid>
                )}
              </Grid>

              <Grid item xs={12}>
                <Typography
                  variant="h6"
                  gutterBottom
                  style={{ fontWeight: "bold" }}
                >
                  تنظیمات عدم مراجعه
                </Typography>

                <FormControlLabel
                  control={
                    <Checkbox
                      checked={expireEnabled}
                      onChange={(e) => setExpireEnabled(e.target.checked)}
                    />
                  }
                  label="فعال‌سازی عدم مراجعه"
                />

                {expireEnabled && (
                  <Grid container spacing={2} style={{ marginTop: 8 }}>
                    <Grid item xs={12} md={6}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={expireLimitToDate}
                            onChange={(e) =>
                              setExpireLimitToDate(e.target.checked)
                            }
                          />
                        }
                        label="محدودیت بر اساس تاریخ"
                      />
                      {expireLimitToDate && (
                        <Box mt={1}>
                          <DatePicker
                            containerClassName="custom-container"
                            calendar={persian}
                            locale={persian_fa}
                            format="HH:mm:ss   YYYY/MM/DD"
                            plugins={[<TimePicker position="right" />]}
                            value={expireDate.date}
                            onChange={(date) =>
                              setExpireDate({
                                date,
                                gregorian: new DateObject({
                                  date,
                                  format: "HH:mm:ss   YYYY/MM/DD",
                                })
                                  .convert(gregorian, gregorian_en)
                                  .format(),
                              })
                            }
                          />
                        </Box>
                      )}
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={expireLimitToDay}
                            onChange={(e) =>
                              setExpireLimitToDay(e.target.checked)
                            }
                          />
                        }
                        label="محدودیت بر اساس تعداد روز"
                      />
                      {expireLimitToDay && (
                        <Box marginTop={"16px"}>
                          <TextField
                            label="تعداد روز"
                            type="number"
                            variant="outlined"
                            fullWidth
                            value={expireDay}
                            onChange={(e) => setExpireDay(e.target.value)}
                            style={{ marginTop: 8 }}
                          />
                        </Box>
                      )}
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={expireReturnToInventory}
                            onChange={(e) =>
                              setExpireReturnToInventory(e.target.checked)
                            }
                          />
                        }
                        label="بازگشت به موجودی"
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <TextField
                        label="درصد جریمه"
                        type="number"
                        fullWidth
                        variant="outlined"
                        value={expirePenalty}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (
                            value === "" ||
                            (Number(value) >= 0 && Number(value) <= 100)
                          ) {
                            setExpirePenalty(value);
                          }
                        }}
                        InputProps={{
                          endAdornment: <span>%</span>,
                        }}
                      />
                    </Grid>
                  </Grid>
                )}
              </Grid>

              <Grid item xs={12}>
                <Typography className={classes.title}>
                  توضیحات دریافت جایزه
                </Typography>
                <CKEditor
                  editor={ClassicEditor}
                  config={{
                    language: "fa",
                    toolbar: [
                      "heading",
                      "|",
                      "bold",
                      "italic",
                      "link",
                      "bulletedList",
                      "numberedList",
                      "blockQuote",
                    ],
                    link: {
                      addTargetToExternalLinks: true,
                      decorators: [
                        {
                          mode: "manual",
                          label: "باز کردن در تب جدید",
                          attributes: {
                            target: "_blank",
                          },
                        },
                      ],
                    },
                  }}
                  data={deliveryNote}
                  onChange={(_, editor) => {
                    const data = editor.getData();
                    setDeliveryNote(data);
                  }}
                />
              </Grid>
            </GridContainer>
          </CmtCardContent>

          <CmtCardFooter
            separator={{
              color: "#bdbdbd",
              borderWidth: 1,
              borderStyle: "solid",
            }}
          >
            <Box>
              {prize ? (
                <>
                  <Button
                    variant="contained"
                    color="secondary"
                    startIcon={<DeleteIcon />}
                    onClick={() => setOpenDialog(true)}
                    style={{ marginRight: 14 }}
                  >
                    حذف
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<EditIcon />}
                    onClick={() => setopenEditDialog(true)}
                    style={{ marginRight: 14 }}
                  >
                    ویرایش
                  </Button>
                </>
              ) : (
                <>
                  <Button
                    variant="outlined"
                    color="primary"
                    startIcon={<Add />}
                    onClick={() => setOpenAddDialog(true)}
                    style={{ marginRight: 14 }}
                  >
                    ایجاد جایزه جدید
                  </Button>
                </>
              )}
            </Box>
          </CmtCardFooter>
        </CmtCard>
      </div>

      {prize && (
        <InventoryLogCard
          logs={inventoryLogs}
          page={inventoryLogPage}
          totalPages={inventoryLogTotalPages}
          purchaseSource={inventoryLogSource}
          onPurchaseSourceChange={(event) => {
            setInventoryLogPage(1);
            setInventoryLogSource(event.target.value);
          }}
          onPageChange={handleInventoryLogPageChange}
        />
      )}

      <Dialog
        open={openDialog}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            آیا از حدف این جایزه اطمینان دارید ؟
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleRemoveAndClose} color="primary">
            تایید
          </Button>
          <Button onClick={handleClose} color="secondary" autoFocus>
            انصراف
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openEditDialog}
        onClose={() => setopenEditDialog(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            آیا از ویرایش این جایزه اطمینان دارید ؟
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleEditAndClose} color="primary">
            تایید
          </Button>
          <Button
            onClick={() => setopenEditDialog(false)}
            color="secondary"
            autoFocus
          >
            انصراف
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openAddDialog}
        onClose={() => setOpenAddDialog(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            آیا از اضافه کردن این جایزه اطمینان دارید ؟
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleAddAndClose} color="primary">
            تایید
          </Button>
          <Button
            onClick={() => setOpenAddDialog(false)}
            color="secondary"
            autoFocus
          >
            انصراف
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={Boolean(inventoryDialog)}
        onClose={closeInventoryDialog}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>
          {inventoryDialog === "add" ? "افزایش موجودی" : "کاهش موجودی"}
        </DialogTitle>
        <DialogContent>
          <Box mb={2}>موجودی فعلی: {prize?.inventory}</Box>
          <TextField
            autoFocus
            fullWidth
            required
            type="number"
            variant="outlined"
            label="تعداد"
            value={inventoryValue}
            inputProps={{
              min: 1,
              max:
                inventoryDialog === "remove" ? prize?.inventory : undefined,
              step: 1,
            }}
            onChange={(event) => setInventoryValue(event.target.value)}
            onWheel={(event) => event.target.blur()}
          />
          <Box mt={2}>
            <TextField
              fullWidth
              required
              multiline
              rows={3}
              variant="outlined"
              label="توضیحات"
              value={inventoryDescription}
              onChange={(event) =>
                setInventoryDescription(event.target.value)
              }
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={closeInventoryDialog}
            disabled={inventorySubmitting}
          >
            انصراف
          </Button>
          <Button
            color="primary"
            variant="contained"
            onClick={handleInventorySubmit}
            disabled={!validInventoryInput || inventorySubmitting}
          >
            {inventorySubmitting ? "در حال ثبت..." : "ثبت"}
          </Button>
        </DialogActions>
      </Dialog>

      <FileUploader
        selectMode
        open={openFileUploader}
        handleClose={() => setOpenFileUploader(false)}
        handleSelect={(selected) => setCover(selected)}
        selectedItem={cover}
        imageSelector={true}
      />
    </React.Fragment>
  );
};

export default Prize;
